var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer hidden-xs-down"},[_c('p',[_vm._v("\n        Made with "),_c('i',{staticClass:"zmdi zmdi-favorite"}),_vm._v(" by ABOnline solutions for "),_c('a',{attrs:{"href":_vm.companyURL}},[_vm._v(_vm._s(_vm.company))]),_vm._v(" © 2018\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48014d80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/Footer.vue
// module id = null
// module chunks = 